import { format, isValid, parseISO } from "date-fns";
import moment from "moment";

interface Options {
  formatString?: string;
  shouldAddInitialHourOfDay?: boolean;
  shouldAddFinalHourOfDay?: boolean;
  emptyValue?: string;
}

const formatStringOrDateObject = (date: string | Date, options?: Options) => {
  if (typeof date === "string") {
    return isValid(parseISO(date))
      ? format(
          parseISO(date),
          options?.formatString ? options.formatString : "dd MMM, yyyy hh:mm a",
        )
      : "";
  } else {
    return isValid(new Date(date))
      ? format(
          new Date(date),
          options?.formatString ? options.formatString : "dd MMM, yyyy hh:mm a",
        )
      : "";
  }
};

export const OLDate = (date?: string | Date, options?: Options) =>
  date
    ? formatStringOrDateObject(new Date(date), options)
    : options?.emptyValue
      ? options.emptyValue
      : "";

export const OLDateWithInitialTimeOfDay = (date?: string | Date) => {
  if (date) {
    if (typeof date === "string") {
      return format(parseISO(date), "yyyy-MM-dd 00:00:00xxx");
    } else {
      return format(new Date(date), "yyyy-MM-dd 00:00:00xxx");
    }
  } else {
    return "";
  }
};

export const OLDateWithFinalTimeOfDay = (date?: string | Date) => {
  if (date) {
    if (typeof date === "string") {
      return format(parseISO(date), "yyyy-MM-dd 23:59:59xxx");
    } else {
      return format(new Date(date), "yyyy-MM-dd 23:59:59xxx");
    }
  } else {
    return "";
  }
};

export const dayNames = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const;

export const monthNames = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
] as const;

export const formatTimeTo12Hours = (time: string) => {
  const timeIn24HourFormat = "HH:mm";
  const timeIn12HourFormat = "hh:mm a";

  if (moment(time, timeIn24HourFormat, true).isValid()) {
    const momentObject = moment(time, timeIn24HourFormat);
    return momentObject.format(timeIn12HourFormat);
  } else {
    return "";
  }
};
